import { render } from "./RiskApplicationApproval.vue?vue&type=template&id=199e409c"
import script from "./RiskApplicationApproval.vue?vue&type=script&lang=js"
export * from "./RiskApplicationApproval.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__